import { QarepaEnumInformation } from '@qarepa/common';

export enum MonthsEnum {
  JANUARY = 1,
  FEBRUARY = 2,
  MARCH = 3,
  APRIL = 4,
  MAY = 5,
  JUNE = 6,
  JULY = 7,
  AUGUST = 8,
  SEPTEMBER = 9,
  OCTOBER = 10,
  NOVEMBER = 11,
  DECEMBER = 12,
}

export const MonthsArray = [
  MonthsEnum.JANUARY,
  MonthsEnum.FEBRUARY,
  MonthsEnum.MARCH,
  MonthsEnum.APRIL,
  MonthsEnum.MAY,
  MonthsEnum.JUNE,
  MonthsEnum.JULY,
  MonthsEnum.AUGUST,
  MonthsEnum.SEPTEMBER,
  MonthsEnum.OCTOBER,
  MonthsEnum.NOVEMBER,
  MonthsEnum.DECEMBER,
];

export const MonthsInfo: QarepaEnumInformation<MonthsEnum> = {
  [MonthsEnum.JANUARY]: {
    name: $localize`Enero`,
  },
  [MonthsEnum.FEBRUARY]: {
    name: $localize`Febrero`,
  },
  [MonthsEnum.MARCH]: {
    name: $localize`Marzo`,
  },
  [MonthsEnum.APRIL]: {
    name: $localize`Abril`,
  },
  [MonthsEnum.MAY]: {
    name: $localize`Mayo`,
  },
  [MonthsEnum.JUNE]: {
    name: $localize`Junio`,
  },
  [MonthsEnum.JULY]: {
    name: $localize`Julio`,
  },
  [MonthsEnum.AUGUST]: {
    name: $localize`Agosto`,
  },
  [MonthsEnum.SEPTEMBER]: {
    name: $localize`Septiembre`,
  },
  [MonthsEnum.OCTOBER]: {
    name: $localize`Octubre`,
  },
  [MonthsEnum.NOVEMBER]: {
    name: $localize`Noviembre`,
  },
  [MonthsEnum.DECEMBER]: {
    name: $localize`Diciembre`,
  },
};
